import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import cn from 'classnames';
import { IconButton } from 'es/app/components/buttons/IconButton';
import SiteSelector from 'es/app/components/layout/SiteSelector';
import { useActiveFacility } from 'es/app/store/hooks';
import { isSystemRoute } from 'es/app/views/system/RouteMap';
import LocalTime from 'es/core/types/LocalTime';
import React, { HTMLAttributes, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './Navbar.module.css';
import { BootstrapStyles } from 'es/app/visuals/styles/BootstrapStyles';

interface IProps {
    onToggleUniversalSearch: () => void;
}

const Navbar = (props: React.PropsWithChildren<HTMLAttributes<HTMLDivElement> & IProps>) => {
    const { onToggleUniversalSearch } = props;
    const { pathname } = useLocation();
    const isFacilityRoute = !isSystemRoute(pathname);
    const classNames = cn(styles.navbar, BootstrapStyles['py-0'], {
        system: !isFacilityRoute,
    });

    useTimeZone();

    return (
        <nav className={classNames}>
            <div>
                <SiteSelector />
            </div>

            <div>
                <IconButton icon={faSearch} onClick={onToggleUniversalSearch} />
            </div>
        </nav>
    );
};

function useTimeZone() {
    const activeFacility = useActiveFacility();
    const { pathname } = useLocation();
    const isFacilityRoute = !isSystemRoute(pathname);

    useEffect(() => {
        if (!isFacilityRoute) {
            LocalTime.IanaTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } else if (activeFacility) {
            LocalTime.IanaTimeZone = activeFacility.ianaTimeZoneId ?? undefined;
        }
    }, [activeFacility, isFacilityRoute]);
}

export default Navbar;
